import { render, staticRenderFns } from "./radio-button-group.vue?vue&type=template&id=7b04b466"
import script from "./radio-button-group.vue?vue&type=script&lang=js"
export * from "./radio-button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports